import { render } from "./SectionCollapse.vue?vue&type=template&id=43bc9f9f"
import script from "./SectionCollapse.vue?vue&type=script&lang=js"
export * from "./SectionCollapse.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__